import React from 'react';
import { Link } from 'react-router-dom';
import Icon from './Icon';

export default function Footer() {
  return (
    <footer className="market-footer">
      <div className="market-footer-main">
        <div>
          <Link to="/" className="market-brand">
            <span className="brand-mark">
              <Icon name="bag" />
            </span>
            max<span>market</span>
          </Link>
          <p>
            Хорошие вещи. Удобный выбор.
            <br />
            Ваш стиль начинается здесь.
          </p>
        </div>
        <nav aria-label="Покупателям">
          <h3>Покупателям</h3>
          <Link to="/">Каталог товаров</Link>
          <Link to="/orders">Мои заказы</Link>
          <Link to="/favorites">Избранное</Link>
          <Link to="/profile">Личный кабинет</Link>
          <Link to="/delivery">Доставка и оплата</Link>
          <Link to="/returns">Возврат товаров</Link>
          <Link to="/contacts">Контакты и реквизиты</Link>
          <Link to="/privacy">Персональные данные</Link>
          <Link to="/offer">Условия покупки</Link>
        </nav>
        <nav aria-label="Продавцам">
          <h3>Продавцам</h3>
          <Link to="/seller">Стать продавцом</Link>
          <Link to="/seller?tab=products">Управлять товарами</Link>
          <Link to="/seller?tab=orders">Заказы магазина</Link>
        </nav>
      </div>
      <div className="market-footer-bottom">
        <span>© {new Date().getFullYear()} MaxMarket</span>
        <span>Найдётся то самое.</span>
      </div>
    </footer>
  );
}
